// extracted by mini-css-extract-plugin
export default {"counter":"styles__counter____o6vS"};